import { useMemo, VFC } from 'react';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { LibraryItemShareStatus } from 'features/analyses/common/LibraryItemCard/PowerPivot/constants/PowerPivotSharingStatus';
import AsyncFailedStatusMessage from './AsyncFailedStatusMessage';
import AsyncInProgressStatusMessage from './AsyncInProgressStatusMessage';

export enum LibraryItemTypeEnum {
  Tableau = 'Tableau',
  PowerPivot = 'PowerPivot',
}

export type LibraryItemType = keyof typeof LibraryItemTypeEnum;

type Props = {
  status: LibraryItemShareStatus;
  type: LibraryItemType;
};

const AsyncSharingStatusMessage: VFC<Props> = ({ status, type }) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const content = useMemo(() => {
    switch (status) {
      case LibraryItemShareStatus.IN_PROGRESS:
        return (
          <AsyncInProgressStatusMessage isPwcUser={isPwcUser} type={type} />
        );
      case LibraryItemShareStatus.FAILED:
        return <AsyncFailedStatusMessage isPwcUser={isPwcUser} type={type} />;
      default:
        return null;
    }
  }, [status, isPwcUser, type]);

  return <div data-testid="async-sharing-status-message">{content}</div>;
};

export default AsyncSharingStatusMessage;
